import { QueryParameterSchema } from './types';

export const intakeTermFilterQueryFilter: QueryParameterSchema<'intakeTermIds'> = {
  getDefaultValue: () => [],
  getValue: ({ queryParameters }) => queryParameters.intakeTermIds,

  fromUrlSearchParams: ({ urlSearchParams }) => ({
    intakeTermIds: (urlSearchParams.get('filter[intakeTermIds]') ?? '').split(','),
  }),
  toUrlSearchParams: ({ value }) => ({ 'filter[intakeTermIds]': value.join(',') }),
  toSearchQuery: ({ value }) => {
    if (!value || value.length === 0) return {};
    return { 'filter[intakeTermIds]': value };
  },
  sanitize: ({ value, staticProps }) => {
    const {
      referenceData: { intakeTerms },
    } = staticProps;
    return { intakeTermIds: value.filter((s) => !!s && !!intakeTerms[s]) };
  },
  getSummaryItems: ({
    value,
    staticProps: {
      referenceData: { intakeTerms },
    },
  }) => {
    return value.map((intakeTerm) => ({
      filterKey: 'intakeTermIds',
      key: intakeTerm,
      label: `${intakeTerms[intakeTerm]?.name}`,
      value: intakeTerm,
    }));
  },
  removeParam: ({ value, removedValue }) => {
    return { intakeTermIds: value.filter((item) => item !== removedValue) };
  },
};
